module.exports = __webpack_public_path__ + "static/media/whats-covered.8c366f30.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/profile/tabs/HomeTab/resources/whats-covered.jpg
// module id = 3479
// module chunks = 0